var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        {
          ref: "messages",
          staticClass:
            "col-lg-6 offset-lg-3 col-12 container-chat-booking chat-messages"
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _vm.articleCategory.categories.length > 0
            ? _c(
                "div",
                { staticClass: "row" },
                _vm._l(_vm.articleCategory.categories, function(
                  category,
                  index
                ) {
                  return _c(
                    "div",
                    { staticClass: "col-6 col-md-4" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "no-style",
                          attrs: { to: "/article/category/" + category.slug }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "card d-flex shadow-sm",
                              staticStyle: { "min-height": "140px" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "text-pink text-right pt-2 px-3"
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        category.has_new_articles ? "New" : " "
                                      ) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "card-body py-0 px-1 align-items-center justify-content-center text-center"
                                },
                                [
                                  category.icon
                                    ? _c("div", [
                                        _c("i", {
                                          staticClass: "fa-2x text-info",
                                          class: category.icon
                                        })
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "card-title mb-0 mt-3 text-dark"
                                    },
                                    [_vm._v(_vm._s(category.name))]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                }),
                0
              )
            : _c("div", [_c("loader")], 1)
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pt-3 px-4" }, [
      _c("h3", [_vm._v("หมวดหมู่บทความ")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f2b84ab2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2b84ab2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/article/Category.vue
// module id = 2142
// module chunks = 0